export default "__VITE_ASSET__DWxwcReW__"